///<reference path="../../App/plugins/DefinitelyTyped/google.maps.d.ts"/>
///<reference path="../../App/plugins/DefinitelyTyped/bootstrap.d.ts"/>
import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { MySharedService } from '../App/shared.service';
import {filterExact} from '../App/filterExact.pipe';

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;
declare function ExportToCSV(item: any[], fileName: string): void;
declare function CSV2JSON(strData: any[]): void;
declare function CSVToArray(strData: any[]): any;

@Component({
    templateUrl: './AppViews/Roster/roster.html'
})

export class RosterComponent implements OnInit {
    userDetail = JSON.parse(localStorage.getItem("userDetail"));
    constant: Constants;
    siteItems: any = [];
    teamItems: any = [];
    rosterItems: any = [];
    siteUserItems: any = [];
    shiftItems: any = [];
    filter: any = {};
    selectFileError: boolean = false;
    fileTypeError: any = false;
    fileName: String = "";
    @ViewChild('RosterCSV') csvFileInput: ElementRef;
    public showLoader = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService,private _filterExact: filterExact) {
        this.constant = new Constants();
        this.filter = { 'SiteId': this.userDetail.SiteId, 'UserId': '', 'TeamId': '', 'FromDate': moment().add(1, 'days').format('DD/MM/YYYY'), 'ToDate': moment().add(1, 'days').endOf('month').format('DD/MM/YYYY') };                     
  this.userDetail = JSON.parse(localStorage.getItem("userDetail"));    
}

    ngOnInit() {      
        this.BindFilters();
    }

 
    GetShift() {       
        this._httpService.ajaxPost('Roster/GetShiftForDownload').subscribe(
            data => {
                this.shiftItems = data["Shift"];
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constant.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public BindFilters() {
        this.showLoader = true;
        var userId = 0;
        if (this.userDetail.SiteUserId != 0) {
            userId = this.userDetail.SiteUserId;
        }

        this._httpService.ajaxPost('Common/GetSite').subscribe(
            data => {
                this.siteItems = data["Site"];
            },
            err => { this.showLoader = false; },
            () => {
                this._httpService.ajaxPost('Team/GetAssignedTeam', { "TeamId": this.userDetail.TeamID, "UserId": userId }).subscribe(
                    data => {
                        this.teamItems = data["AssignedTeam"];
                    },
                    err => { this.showLoader = false; },
                    () => {                        
                        this._httpService.ajaxPost('Users/GetUsersByRoster', {
                            "IsActive": 1,
                            "Team": this.userDetail.TeamID,
                            "UserId": userId
                        }).subscribe(
                            data => {
                                this.siteUserItems = data["Users"];
                            },
                            err => { this.showLoader = false; },
                            () => {
                                this.GetShift();                                                          
                            });
                    });
            }
        );

    }

    public clearFilter() {
        this.filter = { 'SiteId': '', 'TeamId': '', 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY') };
    }

    public GetRoster() {  
        var userdrp=$('#userdrp').val();        
        var UserId = 0;UserId = ((this.filter.UserId == "" || userdrp == null) ? 0 : this.filter.UserId);        
        var TeamId = this.filter.TeamId == "" ? this.userDetail.TeamID :this.filter.TeamId;
        
        this.showLoader = true;
        this._httpService.ajaxPost("Roster/GetRoster", { "UserId": UserId, "LoggedUserId": this.userDetail.SiteUserId, "TeamId": TeamId, "SiteId": this.filter.SiteId, "FromDate": this.filter.FromDate, "ToDate": this.filter.ToDate }).subscribe(
            data => {
                this.rosterItems = data["Roster"];
            },
            err => { this.showLoader = false; this._sharedService.ShowMessage(this.constant.globalError); },
            () => {
                this.showLoader = false;
                this.DownloadExcel();
            }
        );
    }

    ngAfterViewInit() {
        $(".datePicker").datetimepicker({
            format: 'DD/MM/YYYY',
            minDate: moment().add(1, 'days').set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        });
        $("#show-filter").click(function () {
            $(".filter-form").slideToggle();
            this.filter = { 'SiteId': '', 'TeamId': '', 'FromDate': moment().format('DD/MM/YYYY'), 'ToDate': moment().format('DD/MM/YYYY') };
        }).bind(this);
    }
   
    public DownloadShift() {
        ExportToExcel(this.shiftItems, "ShiftMaster", ["ShiftName", "StartTime", "EndTime"], ["ShiftName", "StartTime", "EndTime"]);
    }

    public DownloadExcel() {
        if(this.rosterItems.length > 0){
            ExportToCSV(this.rosterItems, "Roster_" + new Date().getTime());
        }
    }

    getFileName() {
        var files = this.csvFileInput.nativeElement.files;
        if (files.length != 0) {
            var startindex = files[0].name.length;
            var ext = files[0].name.substr(startindex - 4, 4);
            if ((files[0].type == "application/vnd.ms-excel"|| files[0].type=='text/csv') && ext == '.csv' ) {
                this.selectFileError = false;
                this.fileTypeError = false;
            } else {
                this.fileTypeError = true;
                this._sharedService.ShowMessage("error|Plese Select *.csv file.")
            }
            this.fileName = files[0].name;
        } else {
            this.fileName = "";
            this.selectFileError = true;
        }
    }

    public UploadCSVProjectLocation() {
        this.showLoader = true;
        var files = this.csvFileInput.nativeElement.files;
        let itemsItem: any = {};
        let jsonContent: any;
        let jsonData: any = [];
        if (files.length != 0) {
            if (files[0].type == "application/vnd.ms-excel" || files[0].type == "text/csv") {
                itemsItem.ItemIcon = files[0].name;
                this.fileTypeError = false;

                var fileName = files[0];
                if (!fileName) {
                    return;
                }
                var reader = new FileReader();
                reader.onload = file => {
                    var contents: any = file.target;
                    jsonData = JSON.parse(this.CSV2JSON(contents.result));
                    jsonContent = CSV2JSON(contents.result);
                    if (jsonData[0] == "UserId" && jsonData[1] == "EmpName" && jsonData[2] == "EmpCode" && jsonData[3] != "") {
                        this._httpService.ajaxPost("Roster/UploadRoster", { "json": jsonContent,"LoggedUserId": this.userDetail.SiteUserId }).subscribe(
                            data => {
                                if (data["Roster"].length > 0) {
                                    this._sharedService.ShowMessage("error|Please check ErrorMessage within downloaded sheet");
                                    ExportToCSV(data["Roster"], "RosterError_" + new Date().getTime());
                                } else {
                                    this._sharedService.ShowMessage("success|Data Updated Successfully");
                                }

                            },
                            err => { this.showLoader = false; this._sharedService.ShowMessage(this.constant.globalError); },
                            () => {
                                this.showLoader = false;
                            }
                        );
                    } else {
                        this.showLoader = false;
                        this._sharedService.ShowMessage("warning|Invalid Format.")
                    }
                };
                reader.readAsText(fileName);

            }
            else {
                this.fileTypeError = true;
                this.showLoader = false;
            }
        } else {
            this.selectFileError = true;
            this.showLoader = false;
        }

    }

    CSV2JSON(csv) {
        var array = CSVToArray(csv);
        var json = JSON.stringify(array[0]);
        var str = json.replace(/},/g, "},\r\n");
        return str;
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Roster/roster.component.ts
 **/